// Every sign-in that does not already know the user's email goes through the
// email-first /login page, never straight to the hosted UI: the hosted UI's
// default screen offers the workforce IdP button, which is wrong for customers.

// Control characters, DEL and any backslash: never part of a legitimate app
// path, and browsers strip or reinterpret them (a tab or newline inside
// "/\t/evil.example" is dropped, turning it into "//evil.example").
const UNSAFE_CHARS = /[\u0000-\u001F\u007F\\]/;

// Only same-origin, app-relative paths are allowed as a post-login target.
// Anything else (absolute URLs, protocol-relative "//host", backslash or
// control-character tricks) falls back to the home page so returnTo can
// never become an open redirect (security review wave 3, SEC-029). The
// final check resolves the value the way the browser will and requires the
// result to stay on this origin.
export function safeReturnTo(value, origin = currentOrigin()) {
  if (typeof value !== 'string' || !value.startsWith('/')) return '/';
  if (value.startsWith('//') || UNSAFE_CHARS.test(value)) return '/';
  let resolved;
  try {
    resolved = new URL(value, origin);
  } catch {
    return '/';
  }
  if (resolved.origin !== new URL(origin).origin) return '/';
  return value;
}

function currentOrigin() {
  return typeof window !== 'undefined' && window.location?.origin && window.location.origin !== 'null'
    ? window.location.origin
    : 'https://app.invalid';
}

export function loginPath(returnTo = '/') {
  const target = safeReturnTo(returnTo);
  return target === '/' ? '/login' : `/login?returnTo=${encodeURIComponent(target)}`;
}
